import { classRailStyle, type Cover } from "@ui/tokens/classCover";

interface ClassRailProps {
  /** null renders the neutral rule — a task with no class keeps the row aligned. */
  cover: Cover | null;
  /** Omit to let the rule take the height of its row, as a task card does. */
  height?: number;
  className?: string;
}

export const ClassRail = ({ cover, height, className = "" }: ClassRailProps) => {
  return (
    <span
      aria-hidden="true"
      style={cover ? classRailStyle(cover, height) : height === undefined ? undefined : { height }}
      className={`shrink-0 w-rail rounded-sm ${cover ? "" : "bg-line"} ${className}`}
    />
  );
};